import { api } from "../api";
import { isIuguTestMode } from "../config/environment";

const IUGU_ACCOUNT_ID_PATTERN = /^[a-f0-9]{32}$/i;
const CONFIGURATION_ERROR =
  "Não foi possível iniciar o pagamento com cartão. Tente novamente em instantes.";

let accountIdPromise;

const getAccountId = () => {
  if (!accountIdPromise) {
    accountIdPromise = api
      .get("/config/payment")
      .then(({ data }) => String(data?.data?.account_id || "").trim())
      .catch((error) => {
        accountIdPromise = undefined;
        throw new Error(error?.response?.data?.message || CONFIGURATION_ERROR);
      });
  }

  return accountIdPromise;
};

export const configureIugu = async (iugu) => {
  if (!iugu || typeof iugu.setAccountID !== "function") {
    throw new Error("Biblioteca Iugu não carregada corretamente.");
  }

  const accountId = await getAccountId();

  if (!IUGU_ACCOUNT_ID_PATTERN.test(accountId)) {
    accountIdPromise = undefined;
    throw new Error(CONFIGURATION_ERROR);
  }

  iugu.setAccountID(accountId);

  if (isIuguTestMode) {
    if (typeof iugu.setTestMode !== "function") {
      throw new Error("O modo de teste da Iugu não está disponível.");
    }
    iugu.setTestMode(true);
  }
};

export const clearIuguConfigurationCache = () => {
  accountIdPromise = undefined;
};
